import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaLinkedin, FaWhatsapp } from "react-icons/fa";
export default function Footer() {
  const navigate = useNavigate();

  const handleServiceClick = (id) => {
    navigate("/services", { state: { activeServiceId: id } });
    window.scrollTo(0, 0);
  };

  return (
    <footer
      className="pt-10 sm:pt-12"
      style={{ backgroundColor: "#00295A", color: "#f8fafc", paddingTop: "60px", fontFamily: "'Inter', sans-serif" }}
    >
      <div
        className="px-4 sm:px-6"
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
      >

        <div
          className="grid gap-8 sm:gap-10"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "40px",
            paddingBottom: "50px"
          }}
        >

          {/* SECTION 1: ABOUT */}
          <div className="footer-section">
            <h2
              className="text-lg sm:text-xl"
              style={{ color: "#ffffff", fontSize: "24px", marginBottom: "15px", fontWeight: "bold" }}
            >
              CS Manoj & Associates
            </h2>
            <div style={{ width: "50px", height: "3px", backgroundColor: "#94a3b8", marginBottom: "20px" }}></div>
            <p
              className="text-sm sm:text-base"
              style={{ color: "#cbd5e1", lineHeight: "1.7", fontSize: "15px" }}
            >
              Vashi's leading Company Secretary firm providing seamless compliance,
              legal advisory, and business registration services across India.
            </p>
            <div className="flex gap-4 mt-4 sm:mt-5" style={{ display: "flex", gap: "15px", marginTop: "20px" }}>
              <SocialIcon icon={<FaLinkedin />} href="https://www.linkedin.com/in/cs-manoj-ayadi-a745b51a3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" />
              <SocialIcon icon={<FaWhatsapp />} href="https://wa.me/919773112128" />
<motion.a
  href="https://x.com/pcsmanoj?s=21"
  target="_blank"
  whileHover={{ scale: 1.2, backgroundColor: "#94a3b8" }}
  style={{ width: "35px", height: "35px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", textDecoration: "none", fontWeight: "900", fontSize: "16px" }}
>
  𝕏
</motion.a>
            </div>
          </div>

          {/* SECTION 2: SERVICES */}
          <div className="footer-section">
            <h3
              className="text-base sm:text-lg"
              style={{ fontSize: "18px", marginBottom: "20px", color: "#fff", fontWeight: "bold" }}
            >
              Popular Services
            </h3>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <FooterLink onClick={() => handleServiceClick(1)}>Drafting and Vetting of Agreemetns</FooterLink>
              <FooterLink onClick={() => handleServiceClick(2)}>Insolvency and Bankruptcy IBC</FooterLink>
              <FooterLink onClick={() => handleServiceClick(3)}>Gift City–Formation and Compliance</FooterLink>
              <FooterLink onClick={() => handleServiceClick(4)}>Compliance Health Check-up</FooterLink>
              <FooterLink onClick={() => handleServiceClick(5)}>NBFC Compliance</FooterLink>

              <li
                className="text-sm"
                onClick={() => { navigate("/services"); window.scrollTo(0, 0); }}
                style={{ marginTop: "15px", color: "#94a3b8", cursor: "pointer", fontSize: "14px", fontWeight: "bold" }}
              >
                View All Services →
              </li>
            </ul>
          </div>

          {/* SECTION 3: CONTACT */}
          <div className="footer-section">
            <h3
              className="text-base sm:text-lg"
              style={{ fontSize: "18px", marginBottom: "20px", color: "#fff", fontWeight: "bold" }}
            >
              Get In Touch
            </h3>
            <div className="flex flex-col gap-3 sm:gap-4" style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              <div className="flex gap-3 items-start" style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                <FaMapMarkerAlt style={{ color: "#94a3b8", marginTop: "4px", flexShrink: 0 }} />
                <div className="text-sm sm:text-base" style={{ color: "#cbd5e1", fontSize: "14px", lineHeight: "1.5" }}>
                  <strong>Address:</strong> F-79, First Floor, Haware Fantasia, Vashi, Navi Mumbai - 400703
                </div>
              </div>
              <ContactItem icon={<FaEnvelope style={{ color: "#94a3b8" }} />} text="office@csmanojayadi.com" />
              <div className="flex gap-3 items-start" style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                <FaPhoneAlt style={{ color: "#94a3b8", marginTop: "4px", flexShrink: 0 }} />
                <div className="text-sm sm:text-base" style={{ color: "#cbd5e1", fontSize: "14px" }}>
                  022-65027026 / +91 9773112128
                </div>
              </div>
            </div>
          </div>

        </div>

        <div
          className="flex flex-col sm:flex-row gap-3 sm:gap-0 text-center sm:text-left"
          style={{ borderTop: "1px solid rgba(255,255,255,0.1)", padding: "25px 0", display: "flex", justifyContent: "space-between", fontSize: "14px", color: "#94a3b8" }}
        >
          <p>© 2026 CS Manoj & Associates. All rights reserved.</p>
          <div className="flex justify-center sm:justify-end gap-4 sm:gap-5" style={{ display: "flex", gap: "20px" }}>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/about")}>About Us</span>
            <span style={{ cursor: "pointer" }}>Privacy Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ children, onClick }) {
  return (
    <motion.li
      className="text-sm sm:text-base"
      onClick={onClick}
      whileHover={{ x: 5, color: "#94a3b8" }}
      style={{ marginBottom: "12px", color: "#cbd5e1", cursor: "pointer", fontSize: "15px", transition: "0.3s" }}
    >
      {children}
    </motion.li>
  );
}

function ContactItem({ icon, text }) {
  return (
    <div className="flex gap-3 items-start" style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
      <div style={{ marginTop: "4px", flexShrink: 0 }}>{icon}</div>
      <div className="text-sm sm:text-base" style={{ color: "#cbd5e1", fontSize: "14px" }}>{text}</div>
    </div>
  );
}

function SocialIcon({ icon, href }) {
  return (
    <motion.a
      href={href}
      target="_blank"
      whileHover={{ scale: 1.2, backgroundColor: "#94a3b8" }}
      className="w-8 h-8 sm:w-9 sm:h-9"
      style={{ width: "35px", height: "35px", borderRadius: "50%", backgroundColor: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", textDecoration: "none" }}
    >
      {icon}
    </motion.a>
  );
}